<section class="landing-inversores__investment-types">
  <div class="landing-inversores__container landing-inversores__investment-types-inner">
    <h2 class="landing-inversores__section-title">Tipología de inversiones</h2>
    <p class="landing-inversores__section-subtitle landing-inversores__investment-types-lead">
      Desde pisos individuales ya alquilados hasta edificios para reformar e inversiones colaborativas.
    </p>

    <div class="landing-inversores__investment-types-grid">
      <article
        class="landing-inversores__card landing-inversores__shadow-card landing-inversores__product-card"
        *ngFor="let p of products"
      >
        <div class="landing-inversores__product-card-media">
          <img [src]="p.img" [alt]="p.title" width="1200" height="800" loading="lazy" />
          <span class="landing-inversores__product-card-badge">{{ p.badge }}</span>
        </div>
        <div class="landing-inversores__product-card-body">
          <h3 class="landing-inversores__product-card-title">{{ p.title }}</h3>
          <p class="landing-inversores__product-card-desc">{{ p.desc }}</p>
          <dl class="landing-inversores__product-card-rows">
            <div class="landing-inversores__product-card-row">
              <dt>Rentabilidad</dt>
              <dd>{{ p.yieldRange }}</dd>
            </div>
            <div class="landing-inversores__product-card-row">
              <dt>Ticket de inversión</dt>
              <dd>{{ p.ticket }}</dd>
            </div>
            <div class="landing-inversores__product-card-row">
              <dt>Liquidez mínima</dt>
              <dd>{{ p.liquidity }}</dd>
            </div>
            <div class="landing-inversores__product-card-row landing-inversores__product-card-row--last">
              <dt>Plazo</dt>
              <dd>{{ p.time }}</dd>
            </div>
          </dl>
        </div>
      </article>
    </div>

    <p class="landing-inversores__investment-types-footnote">
      Inversión mínima: 100.000€ · Con financiación, desde 60.000€ de capital propio.
    </p>
  </div>
</section>
